// Centralized Branding Configuration
// Tha Advocate Beats — Marz Tha Advocate

export const branding = {
  // Site Identity
  siteName: "Tha Advocate Beats",
  siteTagline: "Premium Hip-Hop Production • Curated Beats • Authentic Sound",
  
  // Logos
  logo: {
    type: "initials",
    initials: "TA",
    imageUrl: "",
  },
  
  // Producer Profile
  producer: {
    name: "Marz Tha Advocate",
    bio: "Self-taught producer and emcee from Nova Scotia, Canada. Crafting authentic hip-hop instrumentals with raw energy and real soul. Every beat tells a story.",
    profilePic: "/logos/marz-profile.jpg",
    location: "Nova Scotia, Canada",
    specialties: ["Hip-Hop", "Boom Bap", "Trap", "Lo-Fi", "Experimental"],
    achievements: [
      "20 years in production",
      "Self-taught engineer & producer",
      "Multi-genre catalog",
      "Independent artist & beatmaker"
    ]
  },
  
  // Hero Section
  hero: {
    title: "Tha Advocate Beats",
    subtitle: "",
    description: "Premium Hip-Hop Production • Curated Beats • Authentic Sound",
  },
  
  // Default Images (fallbacks)
  defaultImages: {
    beatPlaceholder: "https://images.unsplash.com/photo-1511379938547-c1f69419868d?w=500&h=500&fit=crop",
    albumPlaceholder: "https://images.unsplash.com/photo-1619983081563-430f63602796?w=500&h=500&fit=crop",
    merchPlaceholder: "https://images.unsplash.com/photo-1521572163474-6864f9cf17ab?w=500&h=500&fit=crop",
    profilePlaceholder: "https://images.unsplash.com/photo-1535713875002-d1d0cf377fde?w=400&h=400&fit=crop&crop=faces",
  },
  
  // Social Media & Contact
  social: {
    instagram: "https://instagram.com/tharealadvocate",
    twitter: "https://twitter.com/tharealadvocate",
    youtube: "https://youtube.com/@tharealadvocate",
    soundcloud: "https://soundcloud.com/tharealadvocate",
    email: "marzthaadvocate@gmail.com",
  },
  
  // Stats
  stats: {
    totalBeats: "100+",
    artistsServed: "50+",
    yearsExperience: "20",
  },
  
  // About/Bio
  about: {
    shortBio: "Independent hip-hop artist, producer and engineer from Halifax, Nova Scotia. Specializing in authentic beats that hit hard and tell stories.",
    fullBio: `Marz Tha Advocate is a self-taught producer, emcee, and audio engineer from Nova Scotia, Canada. With 20 years of crafting beats across hip-hop, trap, boom bap, and experimental genres, every instrumental comes from a place of real experience and raw creativity.

From dark, gritty boom bap to modern trap production, Tha Advocate Beats delivers quality sound for artists who take their craft seriously. Every beat is designed to inspire and elevate.`
  }
};
